import { render, staticRenderFns } from "./channelHistory.vue?vue&type=template&id=96486f6a&scoped=true"
import script from "./channelHistory.vue?vue&type=script&lang=js"
export * from "./channelHistory.vue?vue&type=script&lang=js"
import style0 from "./channelHistory.vue?vue&type=style&index=0&id=96486f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96486f6a",
  null
  
)

export default component.exports